module.exports = __webpack_public_path__ + "img/preferred-bronze.e3e4fda4.svg";